import React, { useState } from 'react';
import { loginUser } from '../api/auth';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await loginUser(username, password);
      login(data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Check your connection.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-black text-zoddle-green tracking-tight">ZOCS</h1>
          <p className="text-gray-500 text-sm mt-1">Zoddle Operational Control System</p>
        </div>
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
          <h2 className="text-gray-800 text-xl font-bold mb-6">Sign in</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-600 text-sm mb-1">Username</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-gray-50 text-gray-900 rounded-lg px-4 py-3 text-sm border border-gray-200 focus:outline-none focus:border-zoddle-green placeholder-gray-400"
                placeholder="Enter your username" required />
            </div>
            <div>
              <label className="block text-gray-600 text-sm mb-1">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-gray-50 text-gray-900 rounded-lg px-4 py-3 text-sm border border-gray-200 focus:outline-none focus:border-zoddle-green placeholder-gray-400"
                placeholder="Enter your password" required />
            </div>
            {error && <p className="text-zoddle-pink text-sm">{error}</p>}
            <button type="submit" disabled={loading}
              className="w-full bg-zoddle-green text-white font-bold py-3 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed mt-2">
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>
        </div>
        <p className="text-center text-gray-400 text-xs mt-6">Zoddle Internal System — Authorised Staff Only</p>
      </div>
    </div>
  );
}
